var _feFlood, _feGaussianBlur, _feOffset, _feComposite, _feComposite2, _feFlood2, _feGaussianBlur2, _feOffset2, _feComposite3, _feComposite4, _feFlood3, _feGaussianBlur3, _feOffset3, _feComposite5, _feComposite6, _feFlood4, _feGaussianBlur4, _feOffset4, _feComposite7, _feComposite8, _feFlood5, _feGaussianBlur5, _feOffset5, _feComposite9, _feComposite0, _feFlood6, _feGaussianBlur6, _feOffset6, _feComposite1, _feComposite10, _feFlood7, _feGaussianBlur7, _feOffset7, _feComposite11, _feComposite12, _feFlood8, _feGaussianBlur8, _feOffset8, _feComposite13, _feComposite14, _feFlood9, _feGaussianBlur9, _feOffset9, _feComposite15, _feComposite16, _feFlood0, _feGaussianBlur0, _feOffset0, _feComposite17, _feComposite18, _feFlood1, _feGaussianBlur1, _feOffset1, _feComposite19, _feComposite20, _feFlood10, _feGaussianBlur10, _feOffset10, _feComposite21, _feComposite22, _feFlood11, _feGaussianBlur11, _feOffset11, _feComposite23, _feComposite24, _feFlood12, _feGaussianBlur12, _feOffset12, _feComposite25, _feComposite26, _feFlood13, _feGaussianBlur13, _feOffset13, _feComposite27, _feComposite28, _feFlood14, _feGaussianBlur14, _feOffset14, _feComposite29, _feComposite30, _feFlood15, _feGaussianBlur15, _feOffset15, _feComposite31, _feComposite32, _feFlood16, _feGaussianBlur16, _feOffset16, _feComposite33, _feComposite34, _feFlood17, _feGaussianBlur17, _feOffset17, _feComposite35, _feComposite36, _feFlood18, _feGaussianBlur18, _feOffset18, _feComposite37, _feComposite38, _feFlood19, _feGaussianBlur19, _feOffset19, _feComposite39, _feComposite40, _feFlood20, _feGaussianBlur20, _feOffset20, _feComposite41, _feComposite42, _feFlood21, _feGaussianBlur21, _feOffset21, _feComposite43, _feComposite44, _feFlood22, _feGaussianBlur22, _feOffset22, _feComposite45, _feComposite46, _feFlood23, _feGaussianBlur23, _feOffset23, _feComposite47, _feComposite48, _feFlood24, _feGaussianBlur24, _feOffset24, _feComposite49, _feComposite50, _feFlood25, _feGaussianBlur25, _feOffset25, _feComposite51, _feComposite52, _feFlood26, _feGaussianBlur26, _feOffset26, _feComposite53, _feComposite54, _feFlood27, _feGaussianBlur27, _feOffset27, _feComposite55, _feComposite56, _feFlood28, _feGaussianBlur28, _feOffset28, _feComposite57, _feComposite58, _feFlood29, _feGaussianBlur29, _feOffset29, _feComposite59, _feComposite60, _feFlood30, _feGaussianBlur30, _feOffset30, _feComposite61, _feComposite62, _feFlood31, _feGaussianBlur31, _feOffset31, _feComposite63, _feComposite64, _feFlood32, _feGaussianBlur32, _feOffset32, _feComposite65, _feComposite66, _feFlood33, _feGaussianBlur33, _feOffset33, _feComposite67, _feComposite68, _feFlood34, _feGaussianBlur34, _feOffset34, _feComposite69, _feComposite70, _feFlood35, _feGaussianBlur35, _feOffset35, _feComposite71, _feComposite72, _feFlood36, _feGaussianBlur36, _feOffset36, _feComposite73, _feComposite74, _feFlood37, _feGaussianBlur37, _feOffset37, _feComposite75, _feComposite76, _feFlood38, _feGaussianBlur38, _feOffset38, _feComposite77, _feComposite78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldWings = function SvgGoldWings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 1979.965,
    height: 736.26,
    enableBackground: "new 0 0 2250 734"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__N",
    width: 1.124,
    height: 1.12,
    x: -0.033,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__M",
    width: 1.127,
    height: 1.104,
    x: -0.034,
    y: -0.04,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__L",
    width: 1.14,
    height: 1.1,
    x: -0.038,
    y: -0.039,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__K",
    width: 1.064,
    height: 1.119,
    x: -0.017,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__J",
    width: 1.049,
    height: 1.12,
    x: -0.013,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood5 || (_feFlood5 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset5 || (_feOffset5 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite0 || (_feComposite0 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__I",
    width: 1.057,
    height: 1.13,
    x: -0.015,
    y: -0.05,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood6 || (_feFlood6 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset6 || (_feOffset6 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite1 || (_feComposite1 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__H",
    width: 1.052,
    height: 1.109,
    x: -0.014,
    y: -0.042,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood7 || (_feFlood7 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset7 || (_feOffset7 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__G",
    width: 1.051,
    height: 1.12,
    x: -0.014,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood8 || (_feFlood8 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset8 || (_feOffset8 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__F",
    width: 1.05,
    height: 1.122,
    x: -0.013,
    y: -0.047,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood9 || (_feFlood9 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset9 || (_feOffset9 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__E",
    width: 1.206,
    height: 1.088,
    x: -0.055,
    y: -0.034,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood0 || (_feFlood0 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur0 || (_feGaussianBlur0 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset0 || (_feOffset0 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite17 || (_feComposite17 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite18 || (_feComposite18 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__D",
    width: 1.124,
    height: 1.218,
    x: -0.033,
    y: -0.084,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood1 || (_feFlood1 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur1 || (_feGaussianBlur1 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset1 || (_feOffset1 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite19 || (_feComposite19 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite20 || (_feComposite20 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__C",
    width: 1.069,
    height: 1.042,
    x: -0.018,
    y: -0.016,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood10 || (_feFlood10 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur10 || (_feGaussianBlur10 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset10 || (_feOffset10 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite21 || (_feComposite21 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite22 || (_feComposite22 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__B",
    width: 1.12,
    height: 1.177,
    x: -0.032,
    y: -0.068,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood11 || (_feFlood11 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur11 || (_feGaussianBlur11 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset11 || (_feOffset11 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite23 || (_feComposite23 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite24 || (_feComposite24 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__A",
    width: 1.152,
    height: 1.085,
    x: -0.041,
    y: -0.033,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood12 || (_feFlood12 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur12 || (_feGaussianBlur12 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset12 || (_feOffset12 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite25 || (_feComposite25 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite26 || (_feComposite26 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__z",
    width: 1.14,
    height: 1.093,
    x: -0.037,
    y: -0.036,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood13 || (_feFlood13 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur13 || (_feGaussianBlur13 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset13 || (_feOffset13 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite27 || (_feComposite27 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite28 || (_feComposite28 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__y",
    width: 1.08,
    height: 1.133,
    x: -0.021,
    y: -0.051,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood14 || (_feFlood14 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur14 || (_feGaussianBlur14 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset14 || (_feOffset14 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite29 || (_feComposite29 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite30 || (_feComposite30 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__x",
    width: 1.12,
    height: 1.152,
    x: -0.032,
    y: -0.058,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood15 || (_feFlood15 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur15 || (_feGaussianBlur15 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset15 || (_feOffset15 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite31 || (_feComposite31 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite32 || (_feComposite32 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__w",
    width: 1.064,
    height: 1.044,
    x: -0.017,
    y: -0.017,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood16 || (_feFlood16 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur16 || (_feGaussianBlur16 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset16 || (_feOffset16 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite33 || (_feComposite33 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite34 || (_feComposite34 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__v",
    width: 1.137,
    height: 1.252,
    x: -0.037,
    y: -0.097,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood17 || (_feFlood17 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur17 || (_feGaussianBlur17 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset17 || (_feOffset17 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite35 || (_feComposite35 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite36 || (_feComposite36 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__u",
    width: 1.132,
    height: 1.264,
    x: -0.035,
    y: -0.102,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood18 || (_feFlood18 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur18 || (_feGaussianBlur18 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset18 || (_feOffset18 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite37 || (_feComposite37 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite38 || (_feComposite38 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__t",
    width: 1.124,
    height: 1.12,
    x: -0.033,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood19 || (_feFlood19 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur19 || (_feGaussianBlur19 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset19 || (_feOffset19 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite39 || (_feComposite39 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite40 || (_feComposite40 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__s",
    width: 1.127,
    height: 1.104,
    x: -0.034,
    y: -0.04,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood20 || (_feFlood20 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur20 || (_feGaussianBlur20 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset20 || (_feOffset20 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite41 || (_feComposite41 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite42 || (_feComposite42 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__r",
    width: 1.14,
    height: 1.1,
    x: -0.038,
    y: -0.039,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood21 || (_feFlood21 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur21 || (_feGaussianBlur21 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset21 || (_feOffset21 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite43 || (_feComposite43 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite44 || (_feComposite44 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__q",
    width: 1.064,
    height: 1.119,
    x: -0.017,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood22 || (_feFlood22 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur22 || (_feGaussianBlur22 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset22 || (_feOffset22 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite45 || (_feComposite45 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite46 || (_feComposite46 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__p",
    width: 1.049,
    height: 1.12,
    x: -0.013,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood23 || (_feFlood23 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur23 || (_feGaussianBlur23 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset23 || (_feOffset23 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite47 || (_feComposite47 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite48 || (_feComposite48 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__o",
    width: 1.057,
    height: 1.13,
    x: -0.015,
    y: -0.05,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood24 || (_feFlood24 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur24 || (_feGaussianBlur24 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset24 || (_feOffset24 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite49 || (_feComposite49 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite50 || (_feComposite50 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__n",
    width: 1.052,
    height: 1.109,
    x: -0.014,
    y: -0.042,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood25 || (_feFlood25 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur25 || (_feGaussianBlur25 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset25 || (_feOffset25 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite51 || (_feComposite51 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite52 || (_feComposite52 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__m",
    width: 1.051,
    height: 1.12,
    x: -0.014,
    y: -0.046,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood26 || (_feFlood26 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur26 || (_feGaussianBlur26 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset26 || (_feOffset26 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite53 || (_feComposite53 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite54 || (_feComposite54 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__l",
    width: 1.05,
    height: 1.122,
    x: -0.013,
    y: -0.047,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood27 || (_feFlood27 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur27 || (_feGaussianBlur27 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset27 || (_feOffset27 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite55 || (_feComposite55 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite56 || (_feComposite56 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__k",
    width: 1.206,
    height: 1.088,
    x: -0.055,
    y: -0.034,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood28 || (_feFlood28 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur28 || (_feGaussianBlur28 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset28 || (_feOffset28 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite57 || (_feComposite57 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite58 || (_feComposite58 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__j",
    width: 1.124,
    height: 1.218,
    x: -0.033,
    y: -0.084,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood29 || (_feFlood29 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur29 || (_feGaussianBlur29 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset29 || (_feOffset29 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite59 || (_feComposite59 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite60 || (_feComposite60 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__i",
    width: 1.069,
    height: 1.042,
    x: -0.018,
    y: -0.016,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood30 || (_feFlood30 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur30 || (_feGaussianBlur30 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset30 || (_feOffset30 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite61 || (_feComposite61 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite62 || (_feComposite62 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__h",
    width: 1.12,
    height: 1.177,
    x: -0.032,
    y: -0.068,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood31 || (_feFlood31 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur31 || (_feGaussianBlur31 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset31 || (_feOffset31 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite63 || (_feComposite63 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite64 || (_feComposite64 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__g",
    width: 1.152,
    height: 1.085,
    x: -0.041,
    y: -0.033,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood32 || (_feFlood32 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur32 || (_feGaussianBlur32 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset32 || (_feOffset32 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite65 || (_feComposite65 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite66 || (_feComposite66 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__f",
    width: 1.14,
    height: 1.093,
    x: -0.037,
    y: -0.036,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood33 || (_feFlood33 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur33 || (_feGaussianBlur33 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset33 || (_feOffset33 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite67 || (_feComposite67 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite68 || (_feComposite68 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__e",
    width: 1.08,
    height: 1.133,
    x: -0.021,
    y: -0.051,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood34 || (_feFlood34 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur34 || (_feGaussianBlur34 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset34 || (_feOffset34 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite69 || (_feComposite69 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite70 || (_feComposite70 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__d",
    width: 1.12,
    height: 1.152,
    x: -0.032,
    y: -0.058,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood35 || (_feFlood35 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur35 || (_feGaussianBlur35 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset35 || (_feOffset35 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite71 || (_feComposite71 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite72 || (_feComposite72 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__c",
    width: 1.064,
    height: 1.044,
    x: -0.017,
    y: -0.017,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood36 || (_feFlood36 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur36 || (_feGaussianBlur36 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset36 || (_feOffset36 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite73 || (_feComposite73 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite74 || (_feComposite74 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__b",
    width: 1.137,
    height: 1.252,
    x: -0.037,
    y: -0.097,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood37 || (_feFlood37 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur37 || (_feGaussianBlur37 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset37 || (_feOffset37 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite75 || (_feComposite75 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite76 || (_feComposite76 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "gold-wings_svg__a",
    width: 1.132,
    height: 1.264,
    x: -0.035,
    y: -0.102,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood38 || (_feFlood38 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  })), _feGaussianBlur38 || (_feGaussianBlur38 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 2.337
  })), _feOffset38 || (_feOffset38 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.77,
    dy: 3.36,
    "in": "blur",
    result: "offset"
  })), _feComposite77 || (_feComposite77 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  })), _feComposite78 || (_feComposite78 = /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m1500.334 243.235-.865-5.993-24.43 3.04c-38.112 4.723-67.215 2.5-106.427-8.158-25.275-6.874-32.265-2.185-23.793 15.91 5.423 11.584 16.143 18.47 40.56 26.033 23.282 7.225 34.52 9.315 54.4 10.092 22.258.876 32.943-1.91 44.969-11.693 11.59-9.418 16.751-19.354 15.586-29.231",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__a)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1517.427 183.338-1.394-13.351-74.855 13.199-74.799 13.189-1.022 5.308c-.542 2.918-.405 6.312.328 7.528 3.642 6.06 45.74 14.787 88.876 18.397 16.219 1.365 42.962-3.581 50.216-9.277 9.957-7.786 14.232-19.486 12.65-34.993",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__b)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.218 368.398c46.15-59.125 72.874-95.332 90.795-122.978l25.396-39.168 18.008-3.299c9.897-1.812 29.797-6.033 44.207-9.375 25.33-5.876 26.64-6.399 39.255-15.671 10.27-7.542 16.444-14.347 28.859-31.833 13.984-19.694 21.789-33.808 21.078-38.056-.136-.769-46.25 6.715-102.461 16.627l-88.863 15.669a74.6 74.6 0 0 0-25.021 9.259c-17.424 10.318-23.906 15.705-29.025 24.138-8.678 14.278-6.92 31.225 6.27 60.171 5.64 12.387 6.14 14.565 4.58 19.545-2.087 6.686-77.84 91.465-89.465 100.14l-6.471 4.834 5.985 84.207c11.407-15.403 32.683-43.208 56.873-74.21",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__c)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.384 453.539c5.656-1.036 12.018-3.29 14.15-5.03 6.135-4.961 9.317-14.471 7.77-23.244-1.174-6.764-1.936-7.82-5.214-7.242-5.103.9-32.617-5.272-64.864-14.547-18.878-5.447-30.557-10.148-41.352-16.694a18858 18858 0 0 1-27.997-16.976c-20.561-12.487-32.03-14.69-34.663-6.64-4.601 13.986 10.695 28.42 56.985 53.73 27.57 15.092 49.656 25.447 71.6 33.58 11.158 4.14 15.009 4.633 23.585 3.063",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__d)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1337.422 173.191-5.654 6.054 98.3-17.243c109.776-19.257 106.854-18.403 126.016-36.065 16.53-15.17 39.109-48.312 37.851-55.441-.367-2.082-19.068.77-108.841 16.603L1376.51 106.25l-3.681 11.686c-3.627 11.451-23.549 42.562-35.407 55.254",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__e)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.197 592.636c-3.422-4.16-10.58-12.403-15.868-18.326-5.31-5.94-16.831-21.614-25.618-34.852-24.471-36.84-28.43-40.117-44.987-37.198-10.635 1.875-12.033 7.02-7.177 26.385 5.04 20.198 15.6 40.44 34.034 65.266 27.854 37.51 47.676 56.043 66.303 61.919 7.22 2.28 12.333 2.415 22.776.65 12.436-2.115 13.85-2.807 19.017-9.23 3.055-3.803 5.455-7.51 5.33-8.217-.121-.69-10.874-9.72-23.894-20.062-13.019-10.34-26.479-22.197-29.916-26.335",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__f)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.171 648.15c-16.094-16.232-52.882-74.022-55.25-86.798-2.217-11.919-20.13-29.54-30.46-29.965-12.383-.524-17.486 8.326-14.52 25.145 3.74 21.214 20.504 64.118 33.719 86.35 24.205 40.67 36.943 54.536 54.353 59.167 8.927 2.382 23.226.59 33.2-4.164 7.58-3.622 16.338-14.403 15.507-19.115-.316-1.788-7.082-7.816-15.035-13.385-7.95-5.55-17.634-13.31-21.514-17.235",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__g)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.407 388.75c4.714-5.287 8.087-19.92 6.031-26.24-1.286-3.922-2.648-4.238-14.705-3.457-27.696 1.83-53.281-4.297-94.949-22.78-44.29-19.633-50.861-22.047-57.1-20.947-11.492 2.027-8.343 14.223 7.633 29.458 14.45 13.776 62.127 37.479 94.32 46.878 23.505 6.859 24.545 6.983 39.408 4.362 12.46-2.197 16.008-3.533 19.362-7.274",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__h)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.438 444.23c1.183-1.783 2.657-8.13 3.257-14.094l1.105-10.834 14.665-4.833c8.074-2.672 15.374-5.495 16.256-6.265.86-.786.973-4.935.218-9.218-2.496-14.482-1.643-16.4 8.057-18.129 15.996-2.84 21.02-6.472 23.713-17.125 1.318-5.264 2.354-11.265 2.309-13.37-.096-3.267 1.682-4.29 12.012-6.919 6.65-1.71 13.208-4.384 14.523-5.96 1.415-1.67 2.089-7.762 1.635-14.691-1.571-23.287-.802-24.805 15.34-29.975l8.472-2.704-.787-13.611-.786-13.612 7.187-2.804c14.325-5.56 15.298-7.23 12.263-20.848l-2.71-12.101 10.766-7.89c12.127-8.879 16.238-13.771 13.865-16.445-1.125-1.26-20.324 1.49-62.503 8.967l-60.876 10.791-90.117 117.135c-86.113 111.955-90.063 117.433-89.077 123.789.569 3.663.349 19.949-.472 36.206-1.431 28.041-.477 44.235 2.765 46.506.792.57 3.312.702 5.585.302 4.172-.736 5.413-3.605 9.31-21.365.904-4.135 2.849-8.242 4.309-9.114s7.532-.521 13.49.81l10.811 2.395 5.54-5.067c3.043-2.784 7.084-8.182 8.964-12.009 5.934-12.088 10.441-15.495 25.45-19.255 13.313-3.346 13.885-3.697 16.798-10.702 6.264-15.008 5.969-14.725 21.582-19.84 8.332-2.737 15.882-6.316 17.081-8.121",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__i)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.216 330.54c6.017-6.495 8.948-14.924 9.311-25.934.117-4.784-.593-5.542-3.76-4.984-2.048.362-18.298.558-36.122.436-33.378-.222-51.65-2.992-68.301-10.407-8.502-3.782-16.263-6.081-43.746-12.95-15.649-3.905-18.639-2.13-17.297 10.27.906 8.406 1.141 8.652 16.716 18.562 8.696 5.534 20.935 12.325 27.242 15.092 18.656 8.214 60.05 20.023 73.204 20.892 6.742.443 17.735-.381 24.472-1.819 10.219-2.166 13.236-3.678 18.28-9.157",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__j)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.728 575.576c-4.735-7.135-11.986-7.854-13.993-1.373-1.528 4.84 14.989 108.53 20.247 127.134 5.468 19.354 12.708 27.526 28.66 32.28 9.002 2.694 12.72 2.865 19.351.831 17.161-5.273 29.25-10.554 32.168-14.045 2.937-3.494 2.473-4.162-13.75-19.276-9.26-8.622-20.247-20.07-24.442-25.457-8.538-10.958-34.507-62.283-36.199-71.548-1.5-8.07-6.817-20.69-12.042-28.546",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__k)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1729.655 197.614-204.691 36.093-3.26 8.736c-2.449 6.808-8.08 36.953-7.466 40.436.069.391 80.769-13.531 179.296-30.904l179.357-31.645 19.776-10.919c11.028-6.074 23.714-14.724 28.458-19.402 7.687-7.597 14.721-21.07 13.772-26.453-.266-1.509-55.868 7.72-205.242 34.058",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__l)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1513.922 302.869-4.378 8.933c-2.401 4.898-5.43 12.769-6.714 17.47-1.267 4.794-4.83 10.722-7.979 13.563-3.9 3.472-5.397 6.424-4.848 9.535l.795 4.507 167.061-29.496c137.82-24.34 169.4-30.388 179.816-34.49 15.077-5.982 53.345-34.008 57.152-41.823 1.41-2.899 2.683-7.655 2.932-10.6l.215-5.318-192.026 33.86z",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__m)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1804.33 30.805 1629.624 61.61l-9.89 14.707c-5.486 8.096-11.793 18.067-14.141 22.178-3.755 7.02-13.317 19.232-23.62 30.5l-4.675 5.074 168.484-30.14c157.686-28.21 169.19-30.492 178.127-35.358 33.314-18.003 58.823-47.592 55.813-64.662L1979.034 0z",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__n)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1662.084 345.898-170.79 30.134-13.944 21.663c-9.812 15.25-13.7 23.042-13.126 26.301l.818 4.638 145.277-25.617c97.968-17.274 148.138-26.812 154.6-29.372 13.992-5.598 31.286-18.614 51.018-38.494 9.616-9.723 17.364-18.06 17.278-18.544s-77.077 12.688-171.13 29.291",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__o)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1754.328 128.43-207.958 37.168-7.77 23.455c-4.444 12.92-7.768 24.568-7.534 25.89.341 1.938 35.605-3.915 186.952-31.044l186.716-33.48 12.716-7.389c7.15-4.103 17.067-11.036 22.057-15.411 9.5-8.205 24.168-29.573 23.396-33.95-.348-1.974-38.41 4.353-208.575 34.76",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__p)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1454.059 449.775-7.403 7.028c-12.207 11.582-24.258 31.566-28.759 47.647-2.259 8.099-3.919 15.785-3.685 17.108.817 4.637 131.146-20.801 182.87-35.683 32.166-9.263 62.384-23.041 96.51-44.057 16.463-10.105 37.2-27.55 43.004-36.024l4.403-6.615-143.414 25.288z",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__q)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.037 564.951c-32.361-22.447-39.338-28.687-53.88-48.208-14.338-19.23-34.708-39.894-43.07-43.643-9.24-4.151-19.025-2.906-20.845 2.677-1.99 6.035.575 16.875 7.457 31.505 8.6 18.284 10.272 20.793 30.142 44.828 23.283 28.138 33.092 38.68 46.592 50.108 13.044 11.028 15.844 12.531 25.026 13.524 17.11 1.842 41.518-14.388 39.429-26.234-.378-2.142-12.821-12.046-30.851-24.557",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__r)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.33 521.418c-14.578-5.457-32.557-18.111-57.154-40.2-56.45-50.693-76.125-61.204-79.19-42.324-1.553 9.607 2.163 26.102 7.702 34.209 5.712 8.326 45.938 49.455 67.237 68.744 17.531 15.883 29.777 23.038 45.141 26.416 13.943 3.054 22.693 1.818 30.524-4.306 6.717-5.256 15.498-20.804 14.601-25.889-.696-3.949-11.238-10.04-28.861-16.65",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__s)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.58 477.054c-2.075-.767-16.055-6.752-31.038-13.309-40.407-17.649-67.167-32.403-80.62-44.435-23.922-21.42-41.477-29.712-50.933-24.089-4.464 2.67-4.525 3.199-1.764 13.409 5.098 18.785 18.008 31.988 67.25 68.819 28.89 21.6 49.135 33.816 60.603 36.557 3.69.885 10.394 1.01 14.89.255 7.013-1.18 8.912-2.494 13.275-9.12 2.799-4.277 6.675-12.027 8.62-17.229 3.332-8.98 3.311-9.533-.283-10.858",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__t)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.63 243.67.865-5.993 24.43 3.04c38.113 4.723 67.216 2.5 106.428-8.159 25.275-6.873 32.264-2.184 23.793 15.91-5.423 11.585-16.143 18.47-40.56 26.034-23.282 7.225-34.52 9.315-54.4 10.092-22.258.876-32.944-1.91-44.969-11.693-11.59-9.419-16.752-19.355-15.586-29.231",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__u)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.538 183.773 1.394-13.351 74.854 13.199 74.8 13.189 1.022 5.308c.542 2.918.404 6.312-.329 7.527-3.642 6.06-45.74 14.788-88.876 18.398-16.218 1.365-42.962-3.581-50.215-9.277-9.958-7.786-14.232-19.486-12.65-34.993",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__v)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.747 368.833c-46.151-59.125-72.875-95.333-90.796-122.978l-25.395-39.168-18.008-3.299c-9.897-1.812-29.797-6.033-44.207-9.375-25.331-5.876-26.64-6.399-39.255-15.671-10.27-7.542-16.444-14.348-28.86-31.833-13.983-19.694-21.788-33.808-21.077-38.056.135-.769 46.25 6.715 102.461 16.627l88.863 15.669a74.6 74.6 0 0 1 25.02 9.259c17.424 10.318 23.906 15.705 29.026 24.137 8.678 14.279 6.92 31.225-6.27 60.172-5.64 12.387-6.14 14.565-4.58 19.545 2.086 6.686 77.84 91.464 89.465 100.14l6.471 4.833-5.985 84.208c-11.407-15.403-32.683-43.208-56.873-74.21",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__w)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.58 453.974c-5.655-1.036-12.017-3.29-14.15-5.03-6.134-4.961-9.316-14.471-7.77-23.244 1.174-6.764 1.937-7.82 5.215-7.242 5.103.9 32.616-5.273 64.863-14.547 18.879-5.447 30.558-10.148 41.353-16.694 8.277-5.013 20.876-12.643 27.997-16.976 20.56-12.487 32.03-14.69 34.663-6.64 4.601 13.986-10.695 28.42-56.986 53.73-27.569 15.092-49.655 25.447-71.6 33.58-11.157 4.14-15.008 4.633-23.584 3.063",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__x)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.543 173.626 5.654 6.053-98.3-17.242C440.12 143.18 443.042 144.033 423.88 126.372c-16.529-15.17-39.108-48.312-37.85-55.441.366-2.083 19.068.77 108.84 16.603l108.585 19.152 3.681 11.686c3.627 11.451 23.548 42.562 35.407 55.254",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__y)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.768 593.071c3.422-4.16 10.579-12.403 15.868-18.327 5.31-5.938 16.831-21.613 25.618-34.851 24.471-36.84 28.429-40.118 44.987-37.198 10.635 1.875 12.032 7.019 7.177 26.385-5.04 20.198-15.6 40.44-34.034 65.266-27.855 37.51-47.677 56.043-66.304 61.919-7.22 2.28-12.332 2.415-22.775.65-12.436-2.116-13.851-2.807-19.017-9.23-3.056-3.803-5.455-7.51-5.33-8.217.121-.69 10.874-9.721 23.893-20.062 13.02-10.34 26.48-22.197 29.917-26.335",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__z)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.794 648.585c16.094-16.232 52.881-74.022 55.25-86.798 2.216-11.92 20.13-29.54 30.46-29.965 12.383-.524 17.486 8.326 14.52 25.145-3.74 21.214-20.504 64.118-33.719 86.35-24.205 40.67-36.944 54.536-54.353 59.167-8.927 2.382-23.226.59-33.2-4.164-7.58-3.622-16.338-14.403-15.507-19.115.315-1.789 7.082-7.816 15.035-13.385 7.95-5.55 17.634-13.31 21.514-17.235",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__A)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.558 389.185c-4.714-5.287-8.087-19.92-6.032-26.24 1.287-3.922 2.649-4.238 14.706-3.457 27.696 1.83 53.281-4.298 94.949-22.78 44.29-19.634 50.86-22.047 57.1-20.947 11.492 2.027 8.343 14.223-7.633 29.458-14.45 13.776-62.128 37.478-94.32 46.877-23.506 6.86-24.545 6.984-39.408 4.363-12.46-2.197-16.008-3.533-19.362-7.274",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__B)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.527 444.665c-1.184-1.784-2.657-8.131-3.257-14.094l-1.105-10.834-14.665-4.833c-8.075-2.672-15.374-5.495-16.256-6.265-.86-.786-.974-4.935-.218-9.218 2.496-14.482 1.643-16.4-8.057-18.129-15.996-2.84-21.021-6.472-23.713-17.125-1.319-5.264-2.354-11.265-2.31-13.37.097-3.267-1.682-4.291-12.011-6.919-6.65-1.71-13.208-4.384-14.524-5.96-1.414-1.67-2.088-7.762-1.634-14.691 1.57-23.287.802-24.805-15.34-29.975l-8.473-2.704.787-13.612.787-13.611-7.187-2.804c-14.326-5.56-15.299-7.23-12.264-20.848l2.71-12.101-10.765-7.89c-12.127-8.879-16.238-13.771-13.866-16.445 1.125-1.261 20.325 1.49 62.504 8.966l60.876 10.792 90.116 117.135c86.114 111.955 90.064 117.433 89.078 123.788-.569 3.664-.349 19.95.472 36.207 1.431 28.041.477 44.235-2.766 46.505-.792.571-3.312.703-5.584.302-4.172-.735-5.414-3.604-9.31-21.364-.904-4.135-2.85-8.242-4.309-9.114s-7.532-.521-13.49.81l-10.811 2.395-5.54-5.067c-3.043-2.784-7.084-8.182-8.964-12.009-5.934-12.089-10.442-15.495-25.45-19.255-13.313-3.346-13.885-3.697-16.798-10.702-6.265-15.008-5.969-14.726-21.582-19.84-8.332-2.738-15.883-6.316-17.081-8.121",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__C)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.749 330.976c-6.018-6.496-8.948-14.925-9.312-25.936-.116-4.783.593-5.541 3.76-4.983 2.048.361 18.3.557 36.123.436 33.378-.222 51.65-2.992 68.3-10.407 8.503-3.782 16.264-6.082 43.747-12.95 15.648-3.905 18.638-2.13 17.297 10.27-.906 8.406-1.142 8.652-16.716 18.562-8.696 5.534-20.936 12.325-27.243 15.092-18.655 8.214-60.048 20.023-73.203 20.892-6.742.443-17.735-.381-24.472-1.819-10.219-2.167-13.236-3.678-18.281-9.157",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__D)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.237 576.011c4.734-7.135 11.986-7.854 13.993-1.374 1.528 4.84-14.989 108.531-20.247 127.135-5.468 19.354-12.709 27.525-28.66 32.28v-.001c-9.003 2.695-12.72 2.866-19.352.832-17.16-5.273-29.25-10.554-32.168-14.045-2.936-3.494-2.473-4.162 13.75-19.276 9.26-8.623 20.247-20.07 24.442-25.457 8.539-10.958 34.508-62.283 36.2-71.548 1.5-8.07 6.816-20.691 12.042-28.546",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__E)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31 198.049 455 234.142l3.261 8.736c2.449 6.808 8.08 36.953 7.465 40.436-.068.39-80.768-13.531-179.296-30.904l-179.357-31.645-19.776-10.92c-11.027-6.073-23.713-14.724-28.458-19.401-7.686-7.597-14.72-21.07-13.771-26.453.266-1.509 55.868 7.72 205.241 34.058",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__F)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.043 303.304 4.378 8.933c2.4 4.898 5.43 12.768 6.714 17.47 1.267 4.793 4.83 10.722 7.979 13.563 3.9 3.472 5.396 6.424 4.848 9.535l-.795 4.507-167.061-29.496c-137.82-24.34-169.401-30.388-179.817-34.49-15.076-5.982-53.344-34.008-57.151-41.823-1.41-2.899-2.683-7.655-2.933-10.6l-.214-5.318 192.026 33.86z",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__G)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.635 31.24 350.34 62.045l9.89 14.707c5.485 8.096 11.793 18.067 14.14 22.178 3.756 7.02 13.317 19.232 23.621 30.5l4.675 5.073-168.484-30.14C76.496 76.153 64.99 73.872 56.055 69.006 22.74 51.003-2.77 21.414.24 4.344l.69-3.91Z",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__H)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.88 346.333 170.79 30.134 13.944 21.663c9.813 15.25 13.701 23.041 13.127 26.3l-.818 4.638-145.277-25.616c-97.969-17.274-148.138-26.812-154.6-29.372-13.993-5.598-31.286-18.614-51.018-38.494-9.616-9.723-17.364-18.06-17.278-18.544.085-.485 77.076 12.688 171.13 29.291",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__I)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.637 128.865 207.958 37.168 7.77 23.455c4.444 12.92 7.767 24.568 7.534 25.89-.341 1.938-35.605-3.915-186.953-31.044l-186.715-33.48-12.717-7.389c-7.15-4.103-17.066-11.036-22.056-15.411-9.5-8.205-24.168-29.573-23.396-33.95.348-1.974 38.41 4.353 208.575 34.76",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__J)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.906 450.21 7.403 7.028c12.207 11.581 24.258 31.566 28.758 47.647 2.26 8.099 3.92 15.785 3.686 17.107-.817 4.638-131.146-20.8-182.87-35.682-32.166-9.263-62.384-23.041-96.511-44.057-16.463-10.105-37.2-27.55-43.003-36.024l-4.403-6.615 143.414 25.288z",
    style: {
      fill: "#daaa00",
      filter: "url(#gold-wings_svg__K)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.928 565.386c32.361-22.447 39.338-28.687 53.88-48.208 14.337-19.23 34.708-39.894 43.07-43.643 9.24-4.151 19.025-2.906 20.844 2.677 1.99 6.035-.575 16.875-7.456 31.505-8.6 18.283-10.273 20.792-30.143 44.828-23.282 28.138-33.092 38.68-46.59 50.108-13.045 11.028-15.845 12.531-25.027 13.524-17.11 1.842-41.518-14.388-39.43-26.234.378-2.142 12.822-12.046 30.852-24.557",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__L)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.635 521.853c14.578-5.457 32.557-18.111 57.154-40.2 56.45-50.693 76.125-61.204 79.19-42.324 1.552 9.607-2.163 26.101-7.702 34.208-5.712 8.326-45.938 49.456-67.238 68.745-17.53 15.883-29.777 23.037-45.14 26.416-13.943 3.053-22.694 1.818-30.525-4.307-6.716-5.255-15.497-20.803-14.6-25.888.695-3.949 11.237-10.04 28.86-16.65",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__M)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.385 477.489c2.075-.767 16.055-6.752 31.038-13.31 40.406-17.648 67.167-32.402 80.62-44.434 23.921-21.42 41.477-29.712 50.932-24.089 4.465 2.67 4.525 3.199 1.765 13.409-5.098 18.785-18.008 31.988-67.251 68.819-28.89 21.6-49.134 33.816-60.602 36.557-3.69.885-10.395 1.009-14.89.255-7.013-1.18-8.913-2.494-13.275-9.12-2.8-4.277-6.675-12.027-8.62-17.229-3.332-8.98-3.312-9.533.283-10.858",
    style: {
      fill: "#cfb991",
      filter: "url(#gold-wings_svg__N)",
      fillOpacity: 1
    }
  }));
};
export { SvgGoldWings as ReactComponent };
export default __webpack_public_path__ + "static/gold-wings.2bdd4f83.svg";